import React from "react";
import { Card, CardBody } from "reactstrap";

import "./style.scss";
import { MUIIcons, ToolTip } from "../../AbstractElements";
import CheckboxButton from "../../CommonElements/SwitchButton";
import { Mandatory } from "../../utils/Constant";
import { sanitizeString } from "../../utils/helper/helper";

interface LearningPlanCourseCardProps {
  id: any;
  mode?: any;
  title: string;
  isMandatory: boolean;
  onToggleMandatory: () => void;
  onDelete: () => void;
}

const LearningPlanCreationCourseCard: React.FC<LearningPlanCourseCardProps> = ({
  id,
  mode = "ILT",
  title,
  isMandatory,
  onToggleMandatory,
  onDelete,
}) => {
  return (
    <Card className="ccu-card-wrapper">
      <CardBody className="ccu-card-body">
        <div className="ccu-card-header">
          <span className="ccu-course-mode">{mode}</span>
          <div className="ccu-toggle-delete-wrapper">
            <span className="ccu-mandatory-label">{Mandatory}</span>
            <div className="mt-1">
              <CheckboxButton
                showClass
                onChange={onToggleMandatory}
                checked={isMandatory}
              />
            </div>
            <div className="divider me-0" />
            <MUIIcons
              size={22}
              className="primary-icon-color pointer"
              iconName="DeleteOutlined"
              onClick={onDelete}
            />
          </div>
        </div>

        <span id={sanitizeString(`tooltip-create-learning-plan-name-${id}`)}>
          <div className="text-ellips-parent">
            <div
              className="header-text text-ellips ccu-course-title"
              data-fulltext={title}
            >
              {title}
            </div>
          </div>
        </span>
        <ToolTip
          placement="top"
          target={sanitizeString(`tooltip-create-learning-plan-name-${id}`)}
        >
          {title}
        </ToolTip>
      </CardBody>
    </Card>
  );
};

export default LearningPlanCreationCourseCard;
